export enum TwilsockEvent {
    TokenExpired = "tokenExpired",
    TokenAboutToExpire = "tokenAboutToExpire",
    StateChanged = "stateChanged",
    ConnectionError = "connectionError",
    Connected = "connected",
    Disconnected = "disconnected",
    TokenUpdated = "tokenUpdated"
}
